// extracted by mini-css-extract-plugin
export default {"container":"map-main-panel_container__23Ko6","list":"map-main-panel_list__2bHYV","sectionTitle":"map-main-panel_sectionTitle__2VbSO","items":"map-main-panel_items__3wtpK"};